import { Lightning } from '@lightningjs/sdk';
import AbstractLoginSplitContent, {
  AbstractLoginSplitContentTemplateSpec,
} from '../layout/AbstractLoginSplitContent';
import SignUpSection from './SignUpSection';

export interface SignUpContentTemplateSpec
  extends AbstractLoginSplitContentTemplateSpec {
  email: string;
  Content: {
    LeftSection: typeof SignUpSection;
  } & AbstractLoginSplitContentTemplateSpec['Content'];
}

export default class SignUpContent extends AbstractLoginSplitContent {
  private _SignUpSection = this.getByRef('Content')!.getByRef(
    'LeftSection',
  )! as SignUpSection;

  set email(value: string) {
    this._SignUpSection.emailValue = value;
  }

  static override _template(): Lightning.Component.Template<AbstractLoginSplitContentTemplateSpec> {
    const { Content } = super._template();

    return {
      Content: {
        ...Content,
        LeftSection: {
          type: SignUpSection,
          passSignals: {
            $onSignUpLink: true,
            $onCreatePassword: true,
            $onSignUpHovered: true,
            $openKeyboard: true,
            $resetToEmailInput: true,
          },
        },
      },
    };
  }

  override _getFocused() {
    return this._LeftSection;
  }
}
